import React from "react";
import { SvgIcon, SvgIconProps } from "@material-ui/core";
import pure from "recompose/pure";

interface ILogIconProps extends SvgIconProps {}

let Log = (props: SvgIconProps) => (
	<SvgIcon {...props} viewBox="0 0 33 33">
		<rect
			x="7"
			y="7"
			width="18"
			height="18"
			rx="2"
			stroke="black"
			strokeWidth="2"
		/>
		<line x1="22" y1="7" x2="22" y2="25" stroke="black" strokeWidth="2" />
		<rect x="11" y="10" width="7" height="4" rx="1" fill="black" />
	</SvgIcon>
);

// @ts-ignore
Log = pure(Log);
// @ts-ignore
Log.displayName = "LogIcon";
// @ts-ignore
Log.muiName = "SvgIcon";

export default Log;
